/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';

import Panel from '@ts-core/components/Panel';

function QuickLinks({ quickLinks }) {
  return (
    <Panel>
      <Typography variant="subtitle2" gutterBottom>
        <FormattedMessage id="quickLinks.title" />
      </Typography>
      <List dense>
        {quickLinks.map((link, index) => (
          <ListItem button component={Link} to={link.to} key={index}>
            <ListItemIcon style={{ marginRight: 0 }}>
              <link.icon />
            </ListItemIcon>
            <ListItemText primary={link.title} />
          </ListItem>
        ))}
      </List>
    </Panel>
  );
}

QuickLinks.propTypes = {
  quickLinks: PropTypes.array.isRequired,
};

export default QuickLinks;
